import { lazy } from "react";
import { Navigate } from "react-router-dom";

const HomeLayout = lazy(() => import("../layouts/HomeLayout.jsx"));
const DesignLayout = lazy(() => import("../layouts/DesignLayout.jsx"));
const SubmissionLayout = lazy(() => import("../layouts/SubmissionLayout.jsx"));
const ResultLayout = lazy(() => import("../layouts/ResultLayout.jsx"));
const DssLayout = lazy(() => import("../layouts/DssLayout.jsx"));
const UserLayout = lazy(() => import("../layouts/UserLayout.jsx"));
const ErrorLayout = lazy(() => import("../layouts/ErrorLayout.jsx"));

const HomeView = lazy(() => import("../views/home/HomeView.jsx"));
const DesignHomeView = lazy(() => import("../views/design/DesignHomeView.jsx"));
const PreviewHomeView = lazy(() => import("../views/design/preview/PreviewHomeView.jsx"));
const SubmissionHomeView = lazy(() => import("../views/submission/SubmissionHomeView.jsx"));
const SubmissionSuccessView = lazy(() => import("../views/submission/SubmissionSuccessView.jsx"));
const SubmissionClosedView  = lazy(() => import("../views/submission/SubmissionClosedView.jsx"));

const ResultHomeView = lazy(() => import("../views/result/ResultHomeView.jsx"));

const UserFormHomeView = lazy(() => import("../views/user/forms/UserFormHomeView.jsx"));
const ContactGroupHomeView = lazy(() => import("../views/user/contacts/ContactGroupHomeView.jsx"));

const AccountView = lazy(() => import("../views/user/account/AccountView.jsx"));



const SignInView = lazy(() => import("../views/dss/SignInView.jsx"));
const SignUpView = lazy(() => import("../views/dss/SignUpView.jsx"));
const EmailRegistrySuccessView = lazy(() => import("../views/dss/EmailRegistrySuccessView.jsx"));
const PasswordResetView = lazy(() => import("../views/dss/PasswordResetView.jsx"));
const PasswordUpdateView = lazy(() => import("../views/dss/PasswordUpdateView.jsx"));
const PasswordUpdateSuccessView = lazy(() => import("../views/dss/PasswordUpdateSuccessView.jsx"));

const UnAuthorizedView = lazy(() => import("../views/error/UnAuthorizedView.jsx"));
const InvalidResourceView = lazy(() => import("../views/error/InvalidResourceView.jsx"));


/** Research & Development */
const ResearchDevelopmentView = lazy(() => import("../R&D/ResearchDevelopmentView.jsx"));
const UpdateNestedElementView = lazy(() => import("../R&D/UpdateNestedElementView.jsx"));
const DragUpDownListView = lazy(() => import("../R&D/DragUpDownListView.jsx"));
const RecordVoiceView = lazy(() => import("../R&D/RecordVoiceView.jsx"));
const ColorPickerView = lazy(() => import("../R&D/ColorPickerView.jsx"));
const ImageOptionView = lazy(() => import("../R&D/ImageOptionView.jsx"));
const TourView =  lazy(() => import("../R&D/ReactTourView.jsx"));


const ThemeRoutes = [
    {
        path: "/",
        element: <HomeLayout />,
        children: [
            { path: "", exact: true, element: <HomeView /> },
        ]
    },

    {
        path: "/account",
        element: <UserLayout />,
        children: [
            { path: "", exact: true, element: <AccountView /> },
        ]
    },

    {
        path: "/design",
        element: <DesignLayout />,
        children: [
            { path: "", exact: true, element: <DesignHomeView /> },
            { path: "preview/*", exact: true, element: <PreviewHomeView /> },
        ]
    },

    {
        path: "/sub",
        element: <SubmissionLayout />,
        children: [
            { path: "closed", exact: true, element: <SubmissionClosedView /> },
            { path: ":formId/:lookup?", exact: true, element: <SubmissionHomeView /> },
            { path: "success/:subId", exact: true, element: <SubmissionSuccessView /> }
        ]
    },

    {
        path: "/res",
        element: <ResultLayout />,
        children: [
            { path: ":formId/", exact: true, element: <ResultHomeView /> },
        ]
    },

    {
        path: "/dss",
        element: <DssLayout />,
        children: [
            { path: "signin", exact: true, element: <SignInView /> },
            { path: "signup", exact: true, element: <SignUpView /> },
            { path: "registry/success", exact: true, element: <EmailRegistrySuccessView /> },
            { path: "password/reset", exact: true, element: <PasswordResetView /> },
            { path: "password/update", exact: true, element: <PasswordUpdateView /> },
            { path: "password/update/success", exact: true, element: <PasswordUpdateSuccessView /> }
        ]
    },

    {
        path: "/u",
        element: <UserLayout />,
        children: [
            { path: "forms", exact: true, element: <UserFormHomeView /> },
            { path: "contacts", exact: true, element: <ContactGroupHomeView /> },
        ]
    },

    {
        path: "/error",
        element: <ErrorLayout />,
        children: [
            { path: "unauthorized", exact: true, element: <UnAuthorizedView /> },
            { path: "invalid", exact: true, element: <InvalidResourceView /> },
        ]
    },

    {
        path: "/rd",
        element: <DesignLayout />,
        children: [
            { path: "", exact: true, element: <ResearchDevelopmentView /> },
            { path: "TOVFORM-12", exact: true, element: <UpdateNestedElementView /> },
            { path: "TOVFORM-37", exact: true, element: <DragUpDownListView /> },
            { path: "TOVFORM-5", exact: true, element: <RecordVoiceView /> },
            { path: "color", exact: true, element: <ColorPickerView /> },
            { path: "imageoption", exact: true, element: <ImageOptionView /> },
            { path: "tour", exact: true, element: <TourView /> },
        ]
    }

]
export default ThemeRoutes;